import React from 'react';
import useInputController, { isEmpty, createInputValidator } from '../hooks/useInputController';

import type { InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange'> & {
	type?: 'text';
	value: string;
	onChange?: (value: string) => void;
	debounce?: number;
};

const TextInput = React.forwardRef<HTMLInputElement, Props>(
	({ value, onChange, debounce, onBlur: externalOnBlur, ...inputProps }, ref) => {
		const controlled = useInputController(value, onChange, {
			name: inputProps.name,
			debounce,
			format: v => (isEmpty(v) ? '' : String(v)),
			parse: v => v,
			validate: createInputValidator(inputProps)
		});

		function onBlur(event: React.FocusEvent<HTMLInputElement>) {
			controlled.onBlur();
			externalOnBlur?.(event);
		}

		return (
			<input
				{...inputProps}
				type="text"
				value={controlled.value}
				onChange={controlled.onChange}
				onBlur={onBlur}
				ref={ref}
			/>
		);
	}
);

export default TextInput;
